import { Box, Dialog, DialogTitle, DialogContent, InputLabel, FormControl, Button } from "@mui/material";
import { useState } from "react";
import { FieldValues, useForm } from "react-hook-form";
import PlanSelector from "./PlanSelector";
import { updateProxyApplicationPlan } from "../clients/FixieApiClient";
import { toast } from "react-toastify";
import { titleCase } from "title-case";
import { Plan } from "../models";
import { trackConversionEvent } from "../utils/trackEvent";

export interface ModalDialogProps {
  open: boolean;
  applicationId: string;
  onClose: () => void;
  onSuccess: () => void;
}

export interface PlanSelectorDialogProps extends ModalDialogProps {
  applicationPlan: Plan;
  plans: Plan[];
}

export default (props: PlanSelectorDialogProps) => {
  const { register, handleSubmit } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const onSubmit = async (data: FieldValues) => {
    setIsLoading(true);

    const response = await updateProxyApplicationPlan(props.applicationId, data.newPlanName);
    if (response.ok) {
      const proxyApplication = await response.json();
      trackConversionEvent('change_plan', proxyApplication);
      props.onSuccess();
      toast.success(`Updated to ${titleCase(data.newPlanName)}`);
    }
    setIsLoading(false);
  }

  const planName = register('newPlanName', { required: true });

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <DialogTitle>Select Plan</DialogTitle>
      <DialogContent>
        <Box component="form" onSubmit={handleSubmit(onSubmit)} sx={{ minWidth: 280 }}>
          <FormControl fullWidth margin="dense">
            <InputLabel id="select-plan-label">Plan</InputLabel>
            <PlanSelector plans={props.plans} inputRef={planName.ref} onChange={planName.onChange} onBlur={planName.onBlur} name={planName.name} labelId="select-plan-label" proxyType={props.applicationPlan.httpProxy ? 'HTTP' : 'SOCKS'} label="Plan" required variant="outlined" />
          </FormControl>
          <Button
            disabled={isLoading}
            disableElevation
            variant="contained"
            type="submit"
            fullWidth
            sx={{ mt: 2, mb: 2, height: "56px" }}
          >
            Set Plan
          </Button>
        </Box>
      </DialogContent>

    </Dialog >
  );
}
